import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useTranslationCallback = (callback, extraDependencies = []) => {
    const { i18n } = useTranslation();

    useEffect(() => {
        callback();
    }, [i18n.language, ...extraDependencies]);
};

export default useTranslationCallback;
